(()=>{
'use strict';

if(window.fbAiCartFallback)return;
window.fbAiCartFallback=1;

const ROOT=window.Shopify?.routes?.root||'/';
const CART_PATH=(ROOT+'cart').replace(/\/{2,}/g,'/').replace(/\/$/,'')||'/cart';
const ON_CART_PAGE=location.pathname.replace(/\/$/,'')===CART_PATH;
let cartCount=null;
let cartSnapshot=new Map();
let pending=null;
let countObserver=null;

function numberFromCart(c){
  const n=Number(c?.item_count??c?.itemCount);
  return Number.isFinite(n)?n:null;
}

function itemKey(i){
  return String(i?.key||i?.id||i?.variant_id||i?.variantId||'');
}

function snapshotFromCart(c){
  const next=new Map();
  (Array.isArray(c?.items)?c.items:[]).forEach(i=>{
    const key=itemKey(i);
    if(!key)return;
    next.set(key,{qty:Number(i?.quantity)||0,item:i});
  });
  return next;
}

function detectAdded(c){
  const next=snapshotFromCart(c);
  let added=null;

  next.forEach((row,key)=>{
    const before=cartSnapshot.get(key)?.qty||0;
    const delta=row.qty-before;
    if(delta>0&&(!added||delta>added.delta)){
      added={key,delta,item:row.item};
    }
  });

  return {next,added};
}

function addedMessage(added){
  if(!added?.item)return 'Ji, item cart mein add ho gaya ✓';

  const item=added.item;
  const title=String(item.product_title||item.title||'Item').trim();
  const variant=String(item.variant_title||'').trim();
  const variantPart=variant&&variant.toLowerCase()!=='default title'?' — '+variant:'';
  const qty=added.delta===1?'1 pack':added.delta+' packs';

  return `Ji, ${title}${variantPart}, ${qty} cart mein add ho gaya ✓`;
}

function emitConfirmation(message,added){
  const detail={message,delta:added?.delta||1,item:added?.item||null};
  try{document.dispatchEvent(new CustomEvent('fb:ai-cart-confirmed',{detail}));}catch{}
  try{window.dispatchEvent(new CustomEvent('fb:ai-cart-confirmed',{detail}));}catch{}
}

function showToast(added){
  let box=document.getElementById('fb-ai-cart-confirmation');
  let msg;

  if(!box){
    box=document.createElement('div');
    box.id='fb-ai-cart-confirmation';
    box.setAttribute('role','status');
    box.setAttribute('aria-live','polite');
    box.setAttribute('aria-atomic','true');

    const label=document.createElement('strong');
    label.textContent='Falcon AI';
    label.style.whiteSpace='nowrap';

    msg=document.createElement('span');
    msg.setAttribute('data-fb-ai-cart-message','');

    const a=document.createElement('a');
    a.href=ROOT+'cart';
    a.textContent='Review cart';

    box.append(label,msg,a);

    Object.assign(box.style,{
      position:'fixed',top:'16px',right:'16px',zIndex:'2147483000',display:'grid',gridTemplateColumns:'auto 1fr auto',alignItems:'center',gap:'10px 12px',
      maxWidth:'min(560px, calc(100vw - 32px))',padding:'13px 16px',borderRadius:'12px',background:'#111',color:'#fff',
      boxShadow:'0 10px 32px rgba(0,0,0,.24)',font:'inherit',fontSize:'14px',lineHeight:'1.4',opacity:'0',
      transform:'translateY(-8px)',transition:'opacity .18s ease, transform .18s ease'
    });
    Object.assign(a.style,{color:'#fff',fontWeight:'600',textDecoration:'underline',whiteSpace:'nowrap'});

    const mq=window.matchMedia?.('(max-width: 640px)');
    const applyMobile=()=>{
      if(!mq)return;
      if(mq.matches){
        box.style.left='12px';
        box.style.right='12px';
        box.style.top='12px';
        box.style.maxWidth='none';
        box.style.gridTemplateColumns='1fr auto';
        label.style.gridColumn='1 / -1';
      }else{
        box.style.left='auto';
        box.style.right='16px';
        box.style.top='16px';
        box.style.maxWidth='min(560px, calc(100vw - 32px))';
        box.style.gridTemplateColumns='auto 1fr auto';
        label.style.gridColumn='auto';
      }
    };
    applyMobile();
    try{mq?.addEventListener('change',applyMobile);}catch{}

    document.body.append(box);
  }else{
    msg=box.querySelector('[data-fb-ai-cart-message]');
  }

  const message=addedMessage(added);
  if(msg)msg.textContent=message;

  clearTimeout(box._fbHideTimer);
  box.hidden=false;
  requestAnimationFrame(()=>{box.style.opacity='1';box.style.transform='translateY(0)';});
  box._fbHideTimer=setTimeout(()=>{
    box.style.opacity='0';box.style.transform='translateY(-8px)';
    setTimeout(()=>{box.hidden=true;},220);
  },5000);

  emitConfirmation(message,added);
}

function maybeConfirm(c){
  const nextCount=numberFromCart(c);
  if(nextCount===null)return;

  const hasItems=Array.isArray(c?.items);
  const diff=hasItems?detectAdded(c):{next:cartSnapshot,added:null};
  const previousCount=cartCount;

  cartCount=nextCount;
  if(hasItems)cartSnapshot=diff.next;

  if(previousCount===null)return;
  if(nextCount<=previousCount||ON_CART_PAGE)return;

  clearTimeout(pending);
  pending=setTimeout(()=>showToast(diff.added),180);
}

async function syncCart(){
  try{
    const r=await fetch(ROOT+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!r.ok)return;
    maybeConfirm(await r.json());
  }catch{}
}

function cartFromEvent(e){
  const c=e?.detail?.cart;
  if(c&&Array.isArray(c.items))maybeConfirm(c); else syncCart();
}

['cart:updated','cart:change','variant:added','variant:add'].forEach(name=>document.addEventListener(name,cartFromEvent));

function replaceTextNode(root,from,to){
  if(!root)return;
  const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
  const nodes=[];
  while(walker.nextNode())nodes.push(walker.currentNode);
  nodes.forEach(n=>{if(n.nodeValue&&n.nodeValue.includes(from))n.nodeValue=n.nodeValue.replaceAll(from,to);});
}

function hardenBoxFinder(){
  const finder=document.querySelector('.box-finder-section, .fb-finder, [data-box-finder], #box-finder');
  const seo=document.querySelector('.fb-finder-seo');
  if(!finder&&!seo)return;

  const scope=seo||finder;
  const replacements=[
    ['There is no minimum order','Order quantities depend on the selected product and customization'],
    ['there is no minimum order','order quantities depend on the selected product and customization'],
    ['No minimum order','Minimum quantities depend on the selected product and customization'],
    ['no minimum order','minimum quantities depend on the selected product and customization'],
    ['no minimum quantity','minimum quantities depend on the selected product and customization'],
    ['3–5 Day Delivery','Nationwide Delivery'],
    ['3-5 Day Delivery','Nationwide Delivery']
  ];
  replacements.forEach(([from,to])=>replaceTextNode(scope,from,to));

  document.querySelectorAll('script[type="application/ld+json"]').forEach(s=>{
    let text=s.textContent||'';
    if(!/minimum order|minimum quantity|3.?5.*delivery/i.test(text))return;
    text=text
      .replaceAll('There is no minimum order','Order quantities depend on the selected product and customization')
      .replaceAll('there is no minimum order','order quantities depend on the selected product and customization')
      .replaceAll('No minimum order','Minimum quantities depend on the selected product and customization')
      .replaceAll('no minimum order','minimum quantities depend on the selected product and customization')
      .replaceAll('no minimum quantity','minimum quantities depend on the selected product and customization');
    s.textContent=text;
  });

  const adminButton=document.querySelector('[title="Admin Analytics"], [data-admin-analytics], .admin-analytics-button');
  if(adminButton)adminButton.remove();
  if(typeof window.showAdminDashboard==='function')window.showAdminDashboard=function(){return false;};
}

function init(){
  const countEl=document.querySelector('cart-count');
  if(countEl){
    countObserver=new MutationObserver(()=>syncCart());
    countObserver.observe(countEl,{childList:true,subtree:true,characterData:true});
  }
  syncCart();
  hardenBoxFinder();
  setTimeout(hardenBoxFinder,800);
}

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
window.addEventListener('pageshow',()=>{syncCart();hardenBoxFinder();});
document.addEventListener('visibilitychange',()=>{if(!document.hidden)syncCart();});

})();